// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"info-text_wrapper__1PSFr","title":"info-text_title__3LCas","text":"info-text_text__36VCu"};